import React, { useEffect, useState } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';
import { Dialog, DialogContent, DialogTitle, IconButton, Box } from '@mui/material';
import FeatherIcon from 'feather-icons-react';

const QRScannerDialog = ({ open, onClose, onScan }) => {
    useEffect(() => {
        let scanner;
        let timer;

        if (open) {
            timer = setTimeout(() => {
                if (!document.getElementById('reader')) return;

                try {
                    scanner = new Html5QrcodeScanner(
                        'reader',
                        {
                            fps: 10,
                            qrbox: { width: 250, height: 250 },
                        },
                        /* verbose= */ false,
                    );
                    scanner.render(
                        (decodedText) => {
                            onScan(decodedText);
                            if (scanner) {
                                scanner.clear().catch(err => console.warn(err));
                            }
                        },
                        (error) => {
                            // ignore errors
                        },
                    );
                } catch (e) {
                    console.error("Scanner init error", e);
                }
            }, 300); // 300ms delay to ensure Dialog animation is done
        }

        return () => {
            clearTimeout(timer);
            if (scanner) {
                scanner.clear().catch((error) => console.error('Failed to clear html5-qrcode scanner. ', error));
            }
        };
    }, [open, onScan]);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <Box display="flex" justifyContent="space-between" alignItems="center" p={2}>
                <DialogTitle sx={{ p: 0 }}>Scanner QR Code</DialogTitle>
                <IconButton onClick={onClose}>
                    <FeatherIcon icon="x" />
                </IconButton>
            </Box>
            <DialogContent>
                <div id="reader" width="100%"></div>
            </DialogContent>
        </Dialog>
    );
};

export default QRScannerDialog;
